<div id="ic-toast-container"
  [class.show]="state().visible"
  [class.has-footer]="state().pageHasFooter"
  (mouseenter)="toastService.pause()"
  (mouseleave)="toastService.resume()"
  >
  <div id="toast-body">
    @if (state().icon != null && state().icon != ToastIcon.None) {
      <img
        class="prevent-select"
        [src]="iconPath()" alt=""
        >
    }
    <!--		(state?.icon == ToastIcon.Success ? '/assets/svg/toast-success.svg' : '/assets/svg/toast-error.svg')-->
    <div class="prevent-select">{{ $safeNavigationMigration(state().message) | translate }}</div>
    @if (state().showCta && (state().ctaText?.length ?? 0) > 0) {
      <div id="ict-cta" (click)="toastService.onCtaClick()">
        <span class="prevent-select">{{ $safeNavigationMigration(state().ctaText) | translate | uppercase }}</span>
      </div>
    }
    @if (!state().showCta && state().showLink) {
      <div id="ict-link" (click)="toastService.onLinkClick()">
        <span class="prevent-select"><img src="/assets/svg/toast-link.svg" alt=""></span>
      </div>
    }
  </div>
</div>
